import css from 'styled-jsx/css';
import { serif, sansSerif } from 'styles/css-constants';
import { sharedPalette } from 'styles/colors/constants';
import { MQ_LARGE, MQ_MEDIUM } from 'constants/mq';

// Going to explicitly ignore browsers that don't support Grid for now
export default css`
  .TeaserFlipCard__flipBox {
    -ms-transform-style: preserve-3d;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    perspective: 1000px;
    -webkit-perspective: 1000px;
  }

  .TeaserFlipCard__flipBoxFront,
  .TeaserFlipCard__flipBoxBack {
    background-size: cover;
    background-position: center;
    height: 260px;
    -ms-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    -webkit-transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.15);
    background-color: #fff;
  }

  .TeaserFlipCard__flipBoxFront {
    display: flex;
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -webkit-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }

  .TeaserFlipCard__flipBox:hover .TeaserFlipCard__flipBoxFront {
    -ms-transform: rotateY(-180deg);
    -webkit-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
    -webkit-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }

  .TeaserFlipCard__flipBoxBack {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    -ms-transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
    -webkit-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }

  .TeaserFlipCard__flipBox:hover .TeaserFlipCard__flipBoxBack {
    -ms-transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
    -webkit-transform-style: preserve-3d;
    -ms-transform-style: preserve-3d;
    transform-style: preserve-3d;
  }

  .TeaserFlipCard__recipeFront {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .TeaserFlipCard__recipeFront :global(.Teaser) {
    grid-area: 1 / 1 / 2 / 2;
  }

  .TeaserFlipCard__recipeFrontInfo {
    grid-area: 1 / 1 / 2 / 2;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 0 0.5rem 0.5rem;
  }

  .TeaserFlipCard__recipeFrontRating {
    display: flex;
    align-items: flex-start;
    flex-direction: column-reverse;
  }

  .TeaserFlipCard__recipeFrontRatingStar {
    margin-right: 0.125rem;
  }

  .TeaserFlipCard__recipeFrontRatingStar :global(svg) {
    display: block;
    height: 15px;
    width: 15px;
  }

  .TeaserFlipCard__recipeFrontRatingStars {
    margin-right: 0.125rem;
    list-style: none;
    display: flex;
  }

  .TeaserFlipCard__recipeFrontRatingLabel {
    font-size: 12px;
    font-weight: normal;
  }

  .TeaserFlipCard__backInfo {
    padding: 10px;
  }

  .TeaserFlipCard__backInfoToolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1.5rem;
    width: 100%;
  }

  .TeaserFlipCard__backInfoIconButton {
    display: flex;
    align-items: center;
    margin-right: 0.375rem;
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
  }

  .TeaserFlipCard__backInfo h3 {
    font-family: ${serif};
    font-size: var(--baseFontScale);
    font-weight: bold;
  }

  .TeaserFlipCard__backInfoOrganize {
    margin-top: 0.75rem;
  }

  .TeaserFlipCard__backInfoOrganize span {
    color: #5b4746;
    font-size: var(--fontScaleNeg1);
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
    word-wrap: break-word;
  }

  .TeaserFlipCard__backInfoRating {
    margin: 1rem 0;
  }

  .TeaserFlipCard__backInfoNotes {
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .TeaserFlipCard__backInfoNotes label {
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    text-transform: uppercase;
  }

  .TeaserFlipCard__backInfoNotes textarea {
    width: 100%;
    font-family: ${serif};
    font-size: initial;
    padding: 0.25rem;
    resize: none;
  }

  .TeaserFlipCard__backInfoNotes button {
    margin-top: 0.5rem;
    padding: 0.15rem;
    width: 90px;
    height: 30px;
    border: none;
    background: ${sharedPalette.kYellow};
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
  }

  .TeaserFlipCard__backInfoButton {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: var(--baseFontScale);
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    background: #000;
    color: #fff;
    padding: 15px;
    width: 100%;
  }

  .TeaserFlipCard__isUpdatingMessageBox {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: #5b4746;
  }

  .TeaserFlipCard__isUpdatingMessageBox span {
    font-size: var(--fontScaleNeg1);
    font-style: italic;
    color: #fff;
    padding: 0.5rem 1.5rem;
  }

  .TeaserFlipCard__showEditMobileForm {
    background-image: url('https://cdn.apartmenttherapy.info/image/upload/v1600726210/k/recipebox/corner-peel.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 39px;
    height: 60px;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-bottom: 0.25rem;
  }

  .TeaserFlipCard__showEditMobileForm a {
    color: #000;
  }

  .TeaserFlipCard__editMobileForm {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    overflow-y: scroll;
  }

  .TeaserFlipCard__editMobileFormHeader {
    background: #000;
    width: 100%;
    padding: 0.65rem;
  }

  .TeaserFlipCard__editMobileFormHeader a {
    display: flex;
    align-items: center;
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
  }

  .TeaserFlipCard__editMobileFormHeader a span {
    padding-left: 0.5rem;
  }

  .TeaserFlipCard :global(.Error__message) {
    font-size: var(--fontScaleNeg2);
    color: red;
  }

  .TeaserFlipCard__backInfoRating :global(.RecipeRating__text) {
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    font-weight: bold;
    text-transform: none;
  }

  .TeaserFlipCard__backInfoRating :global(.RecipeRating__rateNow) {
    font-size: var(--fontScaleNeg1);
  }

  @media (hover: none) {
    .TeaserFlipCard__flipBoxBack {
      display: none;
    }

    .TeaserFlipCard__flipBoxFront,
    .TeaserFlipCard__flipBoxBack {
      -ms-transition: none;
      transition: none;
      -webkit-transition: none;
    }

    .TeaserFlipCard__flipBox:hover .TeaserFlipCard__flipBoxFront {
      -ms-transform: none;
      -webkit-transform: none;
      transform: none;
      -webkit-transform-style: none;
      -ms-transform-style: none;
      transform-style: none;
    }

    .TeaserFlipCard__flipBox:hover .TeaserFlipCard__flipBoxBack {
      -ms-transform: none;
      -webkit-transform: none;
      transform: none;
      -webkit-transform-style: none;
      -ms-transform-style: none;
      transform-style: none;
    }
  }

  @media screen and ${MQ_MEDIUM} {
    .TeaserFlipCard__flipBoxFront,
    .TeaserFlipCard__flipBoxBack {
      background-size: cover;
      background-position: center;
      height: 300px;
    }

    .TeaserFlipCard__recipeFrontInfo {
      padding: 0.75rem;
    }

    .TeaserFlipCard__recipeFrontRating {
      display: flex;
      align-items: center;
      flex-direction: row;
    }

    .TeaserFlipCard__recipeFrontRatingLabel {
      font-size: 12px;
      font-weight: bold;
    }

    .TeaserFlipCard__backInfoNotes button {
      font-size: var(--fontScaleNeg2);
    }

    .TeaserFlipCard__backInfoButton {
      padding: 10px;
    }
  }

  @media screen and ${MQ_LARGE} {
    .TeaserFlipCard__flipBoxFront,
    .TeaserFlipCard__flipBoxBack {
      background-size: cover;
      background-position: center;
      height: 360px;
    }
  }
`;
